import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import throat from 'throat'
import Web3 from 'web3'

import VaultChefABI from '../abi/VaultChef.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { makeBatchRequest } from '../utils'

export const getPolyCatFarm = async (
  walletAddress: string,
  ct: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  try {
    const { contractAddress, routerAddress } = ct
    const web3 = web3Prop || new Web3(getNodeUrl(137))
    const contract = new web3.eth.Contract(VaultChefABI as any, contractAddress)
    const _poolLength = await contract.methods.poolLength().call()
    const poolArray = [...Array(parseInt(_poolLength))]
    const _userInfoResults = await makeBatchRequest(
      web3,
      poolArray.map((_data, poolId) => {
        return contract.methods.stakedWantTokens(poolId, walletAddress).call
      })
    )
    const _balances = _userInfoResults.map((result, poolId) => {
      return { pool: poolId, balance: result || 0 }
    })
    const poolWhiteList = _balances.filter(({ balance }) => +balance > 0).map(({ pool }) => pool)
    const filteredBalance = _balances.filter(({ pool }) => poolWhiteList.includes(pool))

    if (filteredBalance.length === 0) return []

    const _balancesLP = await makeBatchRequest(
      web3,
      filteredBalance.map((b) => contract.methods.poolInfo(b.pool).call)
    )
    const _balancesLPResult = _balancesLP.map((poolInfo, i) => ({ ...filteredBalance[i], lpAddress: poolInfo[0] }))
    const _balanceLPPair = _balancesLPResult.map(
      throat(80, async (lp: any) => {
        return calculate(
          web3,
          {
            ...lp
          },
          routerAddress,
          tokens,
          priceList
        )
      })
    )

    const completeBalance = await Promise.all(_balanceLPPair)

    const result = completeBalance
      .filter((obj) => obj !== null)
      .map((lp) => {
        return {
          ...lp,
          ...ct,
          availableBalanceOf: '0',
          reward: 0,
          rewardSymbol: ''
        } as Stake
      })
    return result
  } catch (error) {
    console.log('getPolyCatFarm', error)
    return []
  }
}
